import { createAction, props } from '@ngrx/store';
import { AreaPreference } from '../../modules/report-components/models/areaPreference';
import { ExtraAudit } from '../../modules/report-components/models/extraAudit';
import { ScheduledDate } from '../../modules/report-components/models/scheduledDate';

const TAG = `[Customer Scheduling]`;

export const loadAreaPreference = createAction(`${TAG} Load Area Preference`, props<{ reportToken?: string }>());
export const loadAreaPreferenceSuccess = createAction(
  `${TAG} Load Area Preference Success`,
  props<{
    areaPreference: AreaPreference[];
  }>(),
);
export const loadAreaPreferenceError = createAction(
  `${TAG} Load Area Preference Error`,
  props<{
    error: Error;
  }>(),
);

export const loadScheduledDates = createAction(`${TAG} Load Scheduled Dates`, props<{ reportToken?: string }>());
export const loadScheduledDatesSuccess = createAction(
  `${TAG} Load Scheduled Dates Success`,
  props<{
    scheduledDates: ScheduledDate[];
  }>(),
);
export const loadScheduledDatesError = createAction(
  `${TAG} Load Scheduled Dates Error`,
  props<{
    error: Error;
  }>(),
);

export const requestAudit = createAction(`${TAG} Request Audit Preference`, props<{ extraAudit: ExtraAudit; reportToken?: string }>());
export const requestAuditSuccess = createAction(`${TAG} Request Audit Success`);
export const requestAuditError = createAction(`${TAG} Request Audit Error`, props<{ error: Error }>());

export const clearAcceptedStatus = createAction(`${TAG} Clear Accepted Status`);
